import { c as _c } from "react/compiler-runtime";
import { Drawer as MobileDrawer, DrawerContent as MobileDrawerContent, DrawerFooter as MobileDrawerFooter, DrawerHeader as MobileDrawerHeader, DrawerTitle as MobileDrawerTitle } from "@/components/shadcn/ui/drawer";
import { Button, Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle, Divider, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/ui";
import { useCatalogImageLayout } from "@/contexts/catalog-image-layout-provider";
import { useIsMobile } from "@/contexts/is-mobile-provider";
import { formatCurrency, formatList } from "@/lib/format-data";
import { computeBookingFeeCents, formatDisplayPrice, getCancellationFeeInfo } from "@/lib/service-fees";
import { patientFacingDurationLabel } from "@/lib/service-utils";
import { cx } from "@/lib/tailwind-utils";
import { PublicServiceAddon, PublicServiceDetail } from "@/types/service";
import { getServicePricingForSelfSchedule } from "./components/helpers";
interface ServiceDetailsModalProps {
  services?: PublicServiceDetail[];
  isOpen: boolean;
  onClose: () => void;
  onSelect?: () => void;
  /** When false, appointment durations are hidden. Defaults to showing them. */
  showDuration?: boolean;
}
export const ServiceDetailsModal = t0 => {
  const $ = _c(23);
  const {
    services,
    isOpen,
    onClose,
    onSelect,
    showDuration: t1
  } = t0;
  const showDuration = t1 === undefined ? true : t1;
  const {
    isMobile
  } = useIsMobile();
  if (!services?.length) {
    return null;
  }
  let t2;
  if ($[0] !== services) {
    t2 = services?.reduce(_temp, 0);
    $[0] = services;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const shouldShowDrawer = t2 > 100;
  let t3;
  if ($[2] !== services) {
    t3 = formatList(services?.map(_temp2));
    $[2] = services;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const title = t3;
  let t4;
  if ($[4] !== services || $[5] !== showDuration) {
    t4 = services?.map((service_1, index) => <div key={service_1.id} className={cx(services?.length > 1 && "rounded-xl border p-4")}>{services?.length > 1 && <h3 className="text-body-lg"><span><span className="text-primary">Service {index + 1}:</span>{" "}{service_1.name}</span></h3>}<ServiceDetailContent key={service_1.id} service={service_1} showDuration={showDuration} /></div>);
    $[4] = services;
    $[5] = showDuration;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <>{t4}</>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const detailBody = t5;
  let t6;
  if ($[9] !== onClose || $[10] !== onSelect) {
    t6 = !!onSelect && <><Button variant="secondary" onClick={onClose} className="flex-1 basis-1/3">Got it</Button><Button onClick={onSelect} className="flex-1 basis-2/3" variant="primary">Select</Button></>;
    $[9] = onClose;
    $[10] = onSelect;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const footer = t6;
  let t7;
  if ($[12] !== detailBody || $[13] !== footer || $[14] !== isMobile || $[15] !== isOpen || $[16] !== onClose || $[17] !== onSelect || $[18] !== services || $[19] !== shouldShowDrawer || $[20] !== showDuration || $[21] !== title) {
    t7 = shouldShowDrawer ? isMobile ? <MobileDrawer open={isOpen} onOpenChange={onClose}><MobileDrawerContent className="max-h-[90vh]"><MobileDrawerHeader className="pb-1"><MobileDrawerTitle>{title}</MobileDrawerTitle></MobileDrawerHeader><div className="space-y-4 overflow-y-auto px-4">{detailBody}</div><MobileDrawerFooter className="flex-row justify-end gap-2 pt-4">{footer}</MobileDrawerFooter></MobileDrawerContent></MobileDrawer> : <Drawer open={isOpen} onOpenChange={onClose}><DrawerContent side="right"><DrawerHeader className="pb-1"><DrawerTitle>{title}</DrawerTitle></DrawerHeader><DrawerBody className="h-full space-y-4">{detailBody}</DrawerBody><DrawerFooter className="flex-row justify-end gap-2 pt-4">{footer}</DrawerFooter></DrawerContent></Drawer> : <Dialog open={isOpen} onOpenChange={onClose}><DialogContent><DialogHeader className="pb-4"><DialogTitle>{title}</DialogTitle></DialogHeader><DialogBody className="space-y-4 py-1">{services?.map((service_2, index_0) => <div key={service_2.id} className={cx(services?.length > 1 && "rounded-xl border p-4")}>{services?.length > 1 && <h3 className="text-body-lg"><span><span className="text-primary">Service {index_0 + 1}:</span>{" "}{service_2.name}</span></h3>}<ServiceDetailContent key={service_2.id} service={service_2} showDuration={showDuration} /></div>)}</DialogBody><DialogFooter className="flex-row justify-end gap-2 pt-4">{!!onSelect && <><Button variant="secondary" onClick={onClose} className="flex-1 basis-1/3">Got it</Button><Button onClick={onSelect} className="flex-1 basis-2/3" variant="primary">Select</Button></>}</DialogFooter></DialogContent></Dialog>;
    $[12] = detailBody;
    $[13] = footer;
    $[14] = isMobile;
    $[15] = isOpen;
    $[16] = onClose;
    $[17] = onSelect;
    $[18] = services;
    $[19] = shouldShowDrawer;
    $[20] = showDuration;
    $[21] = title;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
interface ServiceDetailsFieldsProps {
  service: PublicServiceDetail;
  bookingFee: number;
  fullBookingFee: boolean;
  showDuration: boolean;
}
const ServiceDetailsFields = t0 => {
  const $ = _c(24);
  const {
    service,
    bookingFee,
    fullBookingFee,
    showDuration
  } = t0;
  let hasPriceVariation;
  let t1;
  let t2;
  if ($[0] !== fullBookingFee || $[1] !== service || $[2] !== showDuration) {
    const pricing = getServicePricingForSelfSchedule(service);
    hasPriceVariation = !!(pricing.estimated || pricing.priceStartsAt || pricing.displayPriceMax !== undefined && pricing.displayPriceMax > pricing.displayPrice);
    const hasDisplayPrice = pricing.displayPrice > 0 || pricing.originalDisplayPrice != null;
    if ($[6] !== service || $[7] !== showDuration) {
      t1 = showDuration && <p><span className="font-semibold">Duration:</span>{" "}{patientFacingDurationLabel(service)} minutes</p>;
      $[6] = service;
      $[7] = showDuration;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    t2 = hasDisplayPrice && <p><span className="font-semibold">{hasPriceVariation ? "Price:" : "Total Price:"}</span>{" "}<span>{formatDisplayPrice(pricing, formatCurrency)}</span>{fullBookingFee && <span>{service.bookingFeeAutoToCredit ? ", deposit" : ", booking fee"}</span>}</p>;
    $[0] = fullBookingFee;
    $[1] = service;
    $[2] = showDuration;
    $[3] = hasPriceVariation;
    $[4] = t1;
    $[5] = t2;
  } else {
    hasPriceVariation = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[9] !== bookingFee || $[10] !== fullBookingFee || $[11] !== service) {
    t3 = !fullBookingFee && bookingFee > 0 && <div className="space-y-1"><p><span className="font-semibold">{service.bookingFeeAutoToCredit ? "Deposit:" : "Booking Fee:"}</span>{" "}<span>{formatCurrency(bookingFee)}</span>{service.hoursBeforeBookingFeeRefundable && <span>{` (Refundable if canceled before ${service.hoursBeforeBookingFeeRefundable}h)`}</span>}</p>{service.bookingFeeText && <p className="text-body leading-relaxed">{service.bookingFeeText}</p>}</div>;
    $[9] = bookingFee;
    $[10] = fullBookingFee;
    $[11] = service;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== bookingFee || $[14] !== service) {
    t4 = bookingFee > 0 && service.bookingFeeAutoToCredit && <p className="text-body leading-relaxed">This deposit becomes a credit you can use toward your appointment.</p>;
    $[13] = bookingFee;
    $[14] = service;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== hasPriceVariation) {
    t5 = hasPriceVariation && <p className="text-caption text-muted-foreground">*price may vary</p>;
    $[16] = hasPriceVariation;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
interface CancellationPolicyProps {
  fees: ReturnType<typeof getCancellationFeeInfo>;
  hasDescription: boolean;
}
const CancellationPolicy = t0 => {
  const $ = _c(14);
  const {
    fees,
    hasDescription
  } = t0;
  if (fees.length === 0) {
    return null;
  }
  const t1 = hasDescription ? "" : "mt-4 space-y-1 border-t border-border pt-4";
  let t2;
  if ($[0] !== hasDescription) {
    t2 = hasDescription && <Divider className="shadow-sm" />;
    $[0] = hasDescription;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h4 className="font-semibold text-foreground-secondary">Cancellation Policy</h4>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== fees) {
    t4 = fees.map(_temp3);
    $[3] = fees;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hasDescription) {
    t5 = hasDescription && <p className="text-body">Otherwise, no cancellation fee will be applied.</p>;
    $[5] = hasDescription;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="space-y-1">{t3}{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t6) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const AddonDetails = t0 => {
  const $ = _c(20);
  const {
    addon,
    showDuration
  } = t0;
  const svc = addon.addonService;
  let t1;
  if ($[0] !== svc) {
    const pricing = getServicePricingForSelfSchedule(svc);
    const hasPromotedFreePrice = pricing.displayPrice === 0 && (!!pricing.promotionName || pricing.originalDisplayPrice != null);
    t1 = pricing.displayPrice > 0 || hasPromotedFreePrice ? hasPromotedFreePrice ? formatCurrency(0) : formatDisplayPrice(pricing, formatCurrency) : null;
    $[0] = svc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const priceLabel = t1;
  let t2;
  if ($[2] !== svc.name) {
    t2 = <span className="font-medium text-foreground">{svc.name}</span>;
    $[2] = svc.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== priceLabel) {
    t3 = priceLabel && <span className="tabular-nums">{priceLabel}</span>;
    $[4] = priceLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== showDuration || $[7] !== svc) {
    t4 = showDuration && <span className="tabular-nums">{patientFacingDurationLabel(svc)}min</span>;
    $[6] = showDuration;
    $[7] = svc;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-baseline gap-2 text-body text-foreground-secondary flex-shrink-0">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="flex items-baseline justify-between gap-2">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== svc.description) {
    t7 = svc.description && <p className="text-caption leading-relaxed text-foreground-secondary">{svc.description}</p>;
    $[15] = svc.description;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="space-y-0.5 text-body">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
const AddonsSection = t0 => {
  const $ = _c(9);
  const {
    addons,
    showDuration
  } = t0;
  if (addons.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider className="shadow-sm" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h4 className="font-semibold text-foreground-secondary">Add-ons</h4>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== addons || $[3] !== showDuration) {
    let t4;
    if ($[5] !== showDuration) {
      t4 = addon => <AddonDetails key={addon.id} addon={addon} showDuration={showDuration} />;
      $[5] = showDuration;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = addons.map(t4);
    $[2] = addons;
    $[3] = showDuration;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <>{t1}<div className="space-y-1">{t2}<div className="space-y-3">{t3}</div></div></>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const ServiceDetailContent = t0 => {
  const $ = _c(28);
  const {
    service,
    showDuration: t1
  } = t0;
  const showDuration = t1 === undefined ? true : t1;
  const {
    catalogImageLayout
  } = useCatalogImageLayout();
  const usesSquareImage = catalogImageLayout === "SQUARE";
  if (!service) {
    return null;
  }
  const bookingFee = computeBookingFeeCents(service);
  const fullBookingFee = bookingFee > 0 && bookingFee === (service.displayPrice || 0);
  let t2;
  if ($[0] !== service) {
    t2 = getCancellationFeeInfo(service);
    $[0] = service;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cancellationFees = t2;
  const hasDescription = !!service.description;
  let t3;
  if ($[2] !== service.addons) {
    t3 = service.addons ?? [];
    $[2] = service.addons;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const addons = t3;
  let t4;
  if ($[4] !== service.image || $[5] !== service.name || $[6] !== usesSquareImage) {
    t4 = service.image && <img src={service.image} alt={service.name} className={cx("mb-2 w-full rounded-lg", usesSquareImage ? "mx-auto aspect-square max-w-[320px] bg-background object-contain" : "aspect-video object-cover")} />;
    $[4] = service.image;
    $[5] = service.name;
    $[6] = usesSquareImage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== hasDescription || $[9] !== service.description) {
    t5 = hasDescription && <><h4 className="font-semibold text-foreground-secondary">Description</h4><p className="whitespace-pre-wrap leading-relaxed">{service.description}</p><Divider className="my-2 shadow-sm" /><h4 className="font-semibold text-foreground-secondary">Details</h4></>;
    $[8] = hasDescription;
    $[9] = service.description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== bookingFee || $[12] !== fullBookingFee || $[13] !== service || $[14] !== showDuration) {
    t6 = <ServiceDetailsFields service={service} bookingFee={bookingFee} fullBookingFee={fullBookingFee} showDuration={showDuration} />;
    $[11] = bookingFee;
    $[12] = fullBookingFee;
    $[13] = service;
    $[14] = showDuration;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== cancellationFees || $[17] !== hasDescription) {
    t7 = <CancellationPolicy fees={cancellationFees} hasDescription={hasDescription} />;
    $[16] = cancellationFees;
    $[17] = hasDescription;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== addons || $[20] !== showDuration) {
    t8 = <AddonsSection addons={addons} showDuration={showDuration} />;
    $[19] = addons;
    $[20] = showDuration;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <div className="space-y-2">{t4}{t5}{t6}{t7}{t8}</div>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
function _temp(acc, service) {
  return acc + (service.description?.length ?? 0);
}
function _temp2(service_0) {
  return service_0.name;
}
function _temp3(fee, index) {
  return <p key={index} className="text-body">{fee.amountCents !== undefined && <span className="font-medium">{formatCurrency(fee.amountCents)} cancellation fee{" "}</span>}{fee.text}</p>;
}